/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-19 14:42:59
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-18 15:20:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/Preview/index.tsx
 */
import React, { Fragment } from 'react';

import {
  ProductCartItem,
  BottomMenu,
  ProductGrid,
  Button,
  ProductFlashSale,
  ProductDetailCarousel,
  ProductInformation,
  ProductIntroduction,
  ImagePlaceholder,
} from 'unifyxp-ecomm-components';
import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';

import styles from './style.module.less';
import DiscountButton from './DiscountButton';
import { ChannelType } from 'src/types/common/SalesChannel';

import { withDraggableId } from 'src/constrains/Preview/util';
import {
  EnumCollapseId,
  onCollapseOpen,
  getState,
  getOpeningCollapse2,
} from '../slice';
import { useSelector } from 'react-redux';
import { productGridData_Two } from 'src/mock';

const _TabBarStyle = withDraggableId(
  BottomMenu,
  EnumCollapseId.productDetailsPageTabBarStyle,
  onCollapseOpen,
);
const WrappedBottomMenu = ({
  iconText,
  addToCart,
  buyNow,
  soldOutFlag,
  soldOut,
  remindMe,
}) => {
  return (
    <div className={styles.btnBottomContainer}>
      <div className={styles.menu}>
        <_TabBarStyle
          buyNowButtonBackgroundColour={
            soldOutFlag ? remindMe.backgroundColor : buyNow.backgroundColor
          }
          buyNowButtonTextColour={
            soldOutFlag ? remindMe.textColor : buyNow.textColor
          }
          addToCartBackgroundColour={
            soldOutFlag ? soldOut.backgroundColor : addToCart.backgroundColor
          }
          addToCartTextColour={
            soldOutFlag ? soldOut.textColor : addToCart.textColor
          }
          homePageIconBackgroundColour={iconText.backgroundColor}
          homePageIconColour={iconText.textColor}
          soldOut={soldOutFlag}
        />
      </div>
    </div>
  );
};
const WrappedRemainProduct = ({ remainingStockTextStyle }) => {
  return (
    <div>
      <ProductDetailCarousel data={['']} />
      <div className={styles.informationContainer}>
        <ProductInformation
          product={{
            title: 'Product Name',
            subTitle: 'Subtitle',
            isSoldOut: false,
            lp: 'HKD 1,000.00',
            stockAmount: 0,
            stockAmountColor: remainingStockTextStyle,
            skuData: { title: '111', skus: [] },
          }}
          style={{ background: '#ffffff' }}
        />
      </div>

      <ProductIntroduction
        style={{ color: 'red' }}
        data={{ text: 'content', images: [''] }}
      />
    </div>
  );
};
const WrappedProduct = ({
  comingSoonStatus,
  comingSoonPrice,
  saleNow,
  saleNowStatus,
  saleNowPrice,
  salesNowCountDownTimer,
}) => {
  const data = {
    saleNow: saleNow,
    statusBackgroundColor: saleNow
      ? saleNowStatus.backgroundColor
      : comingSoonStatus.backgroundColor,
    statusTextColor: saleNow
      ? saleNowStatus.textColor
      : comingSoonStatus.textColor,
    countDownBackgroundColor: salesNowCountDownTimer.backgroundColor,
    countDownTextColor: salesNowCountDownTimer.textColor,
    priceSectionBackgroundColor: saleNow
      ? saleNowPrice.backgroundColor
      : comingSoonPrice.backgroundColor,
    priceSectionTextColor: saleNow
      ? saleNowPrice.textColor
      : comingSoonPrice.textColor,
    priceTitle: 'Flash Sale',
    price: '200',
    statusText: saleNow ? 'Sale Now' : 'Coming Soon',
    countDownTime: saleNow ? '11:11:11' : 'July 28 00:00',
    secondPrice: '300',
    currency: 'CNY',
    secondCurrency: 'AUE',
  };
  return (
    <div>
      <ProductDetailCarousel data={['']} />
      <ProductFlashSale {...data} />
      <div className={styles.informationContainer}>
        <ProductInformation
          product={{
            title: 'Product Name',
            subTitle: 'Subtitle',
            isSoldOut: false,
            lp: 'HKD 1,000.00',
            skuData: { title: '111', skus: [] },
          }}
          style={{ background: '#ffffff' }}
        />
      </div>

      <ProductIntroduction
        style={{ color: 'red' }}
        data={{ text: 'content', images: [''] }}
      />
    </div>
  );
};
const _Primary = withDraggableId(
  Button,
  EnumCollapseId.primaryCallToActionButtonStyle,
  onCollapseOpen,
);
const _Secondary = withDraggableId(
  Button,
  EnumCollapseId.secondaryCallToActionButtonStyle,
  onCollapseOpen,
);
const WrappedActionButton = ({
  buyNowButtonBackgroundColour,
  buyNowButtonTextColour,
  addToCartBackgroundColour,
  addToCartTextColour,
  quantityButtonBackgroundColour,
  quantityButtonTextColour,
  homePageIconBackgroundColour,
  homePageIconColour,
  backgroundColour,
  primaryTextColor,
  outlineColour,
  secondaryTextColor,
}) => {
  //textColour

  return (
    <div className={styles.btnBottomContainer}>
      <div className={styles.topContainer}>
        <div className={styles.wrapper}>
          <div className={styles.addToCartNotice}>
            <span className={styles.addToCartNoticeText}>已成功加入購物車</span>
          </div>
          <div className={styles.productGridContainer}>
            <ProductCartItem
              defaultCounterContent={<span className={styles.count}>x5</span>}
              showPrice
              price={12.0}
              currency={'HKD'}
              secondCurrency={'RMB'}
              secondPrice={13.0}
              title={'Mario'}
              desc={'Mario'}
              imageUrl={
                'https://image-uat.unifyxp.com/images/Product/8ac07265-af63-4471-a4aa-8f3ba947b0ee.png'
              }
            />
          </div>
          <div className={styles.button1}>
            <_Primary
              className={styles.btn}
              style={{
                backgroundColor: backgroundColour,
                background: backgroundColour,
                borderColor: backgroundColour,
                color: primaryTextColor,
              }}>
              查看购物车
            </_Primary>
          </div>
          <div className={styles.button2}>
            <_Secondary
              className={styles.btn}
              style={{
                borderColor: outlineColour,
                color: secondaryTextColor,
              }}>
              继续逛逛
            </_Secondary>
          </div>
        </div>
      </div>
      <div className={styles.menuOpacity}>
        <BottomMenu
          buyNowButtonBackgroundColour={buyNowButtonBackgroundColour}
          buyNowButtonTextColour={buyNowButtonTextColour}
          addToCartBackgroundColour={addToCartBackgroundColour}
          addToCartTextColour={addToCartTextColour}
          quantityButtonBackgroundColour={quantityButtonBackgroundColour}
          quantityButtonTextColour={quantityButtonTextColour}
          homePageIconBackgroundColour={homePageIconBackgroundColour}
          homePageIconColour={homePageIconColour}
        />
      </div>
    </div>
  );
};
enum XInOne {
  ONE_IN_ONE,
  TWO_IN_ONE,
  THREE_IN_ONE,
  FOUR_IN_ONE,
  FIVE_IN_ONE,
}
const WrappedFont = ({ fontFamily, logographicFont, alphabetFont }) => {
  let cnFont = '';
  if (logographicFont == 'Serif') {
    cnFont = 'serif';
  } else if (logographicFont == 'Sans serif') {
    cnFont = 'sans-serif';
  }

  let enFont = '';
  if (alphabetFont == 'Serif') {
    enFont = 'Garamond,Merriweather,Roboto Slab,Playfair Display,Lora,PT Serif';
  } else if ((alphabetFont = 'Sans serif')) {
    enFont = 'Roboto,Open Sans,Noto Sans JP,Lato,Montserrat';
  } else if ((alphabetFont = 'Monospace')) {
    enFont = 'Roboto Mono,Inconsolata,Source Code Pro,IBM Plex Mono,PT Mono';
  }

  return (
    <div className={styles.fontContainer}>
      <ProductGrid
        style={{
          backgroundColor: '#fff',
          fontFamily: `'${fontFamily}',${enFont},${cnFont}`,
        }}
        type={XInOne.TWO_IN_ONE}
        data={productGridData_Two}
      />
    </div>
  );
};

//const _Font = withDraggableId(HotTags, EnumCollapseId.font, onCollapseOpen);

function Preview({ channelType }) {
  const _data: any = useSelector(getState());
  const {
    productDetailsPageTabBarStyle = {},
    primaryCallToActionButtonStyle = {},
    secondaryCallToActionButtonStyle = {},
    font = {},
    flashSaleBarStyle = {},
    remainingStockTextStyle = '',
    miniProgramNavBar,
  } = _data;
  const {
    font: fontFamily = 'Open Sans',
    logographicFont = '',
    alphabetFont = '',
  } = font;
  const { backgroundColor, textColor: primaryTextColor } =
    primaryCallToActionButtonStyle;
  const {
    backgroundColor: secondaryBackgroundColor,
    textColor: secondaryTextColor,
  } = secondaryCallToActionButtonStyle;
  const {
    backgroundColor: miniProgramNavBarBackgroundColor,
    fontColor: miniProgramNavBarFontColor,
  } = miniProgramNavBar;

  const openingCollapse = useSelector(getOpeningCollapse2());

  const [key] = openingCollapse || [];
  const generateRender = () => {
    if (key === EnumCollapseId.productDetailsPageTabBarStyle) {
      return <WrappedBottomMenu {...productDetailsPageTabBarStyle} />;
    }
    if (
      channelType === ChannelType.MiniProgram &&
      (key === EnumCollapseId.primaryCallToActionButtonStyle ||
        key === EnumCollapseId.secondaryCallToActionButtonStyle)
    ) {
      return (
        <Fragment>
          <ImagePlaceholder width={'100%'} height={'calc(100% - 80px)'} />
          <DiscountButton
            backgroundColour={backgroundColor}
            primaryTextColor={primaryTextColor}
            outlineColour={secondaryBackgroundColor}
            secondaryTextColor={secondaryTextColor}
          />
        </Fragment>
      );
    }
    if (
      channelType !== ChannelType.MiniProgram &&
      (key === EnumCollapseId.primaryCallToActionButtonStyle ||
        key === EnumCollapseId.secondaryCallToActionButtonStyle)
    ) {
      return (
        <WrappedActionButton
          {...productDetailsPageTabBarStyle}
          backgroundColour={backgroundColor}
          primaryTextColor={primaryTextColor}
          outlineColour={secondaryBackgroundColor}
          secondaryTextColor={secondaryTextColor}
        />
      );
    }
    if (key === EnumCollapseId.font) {
      return (
        <WrappedFont
          fontFamily={fontFamily}
          logographicFont={logographicFont}
          alphabetFont={alphabetFont}
        />
      );
    }
    if (key === EnumCollapseId.flashSaleBarStyle) {
      return <WrappedProduct {...flashSaleBarStyle} />;
    }
    if (key === EnumCollapseId.remainingStockTextStyle) {
      return (
        <WrappedRemainProduct
          remainingStockTextStyle={remainingStockTextStyle}
        />
      );
    }
    return (
      <div className={styles.empty}>
        <ImagePlaceholder width={'100%'} height={'100vh'} />
      </div>
    );
  };
  return (
    <PreviewContainer
      appearanceStyle={{
        backgroundColor: miniProgramNavBarBackgroundColor,
        arrowColor: miniProgramNavBarFontColor,
        textColor: miniProgramNavBarFontColor,
        operationIconColor: miniProgramNavBarFontColor,
      }}
      className={styles.previewContainer}
      style={{ fontFamily: fontFamily || 'Open Sans' }}>
      {generateRender()}
    </PreviewContainer>
  );
}

export default Preview;
